import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

import { Button } from 'components/Button';

import { PanelCard, PanelGroup, PanelHeading, PanelHelp, PanelSubtext, StepItem, StepMarker, Steps } from './styles';

export type AcknowledgePanelProps = {
  hasReadToEnd: boolean;
  onAcknowledge: () => void;
};

export const AcknowledgeIntro = (): React.ReactElement => (
  <PanelGroup>
    <PanelHeading>Acknowledge document</PanelHeading>
    <PanelSubtext>Read the full document, then confirm your acknowledgement.</PanelSubtext>
  </PanelGroup>
);

export const AcknowledgeSteps = ({ hasReadToEnd, onAcknowledge }: AcknowledgePanelProps): React.ReactElement => (
  <>
    <Steps>
      <StepItem $done={hasReadToEnd}>
        <StepMarker $done={hasReadToEnd}>{hasReadToEnd ? <CheckIcon fontSize="inherit" /> : 1}</StepMarker>
        Read the document
      </StepItem>
      <StepItem $done={false}>
        <StepMarker $done={false}>2</StepMarker>
        Sign and acknowledge
      </StepItem>
    </Steps>
    <PanelGroup>
      <Button
        variant="contained"
        size="large"
        fullWidth
        disabled={!hasReadToEnd}
        aria-disabled={!hasReadToEnd}
        startIcon={hasReadToEnd ? undefined : <LockOutlinedIcon />}
        onClick={onAcknowledge}
      >
        {hasReadToEnd ? 'Acknowledge' : 'Scroll to continue reading'}
      </Button>
      {!hasReadToEnd && <PanelHelp>Read to the end of the document to acknowledge.</PanelHelp>}
    </PanelGroup>
  </>
);

const AcknowledgePanel = ({ hasReadToEnd, onAcknowledge }: AcknowledgePanelProps): React.ReactElement => (
  <PanelCard aria-label="Acknowledge document">
    <AcknowledgeIntro />
    <AcknowledgeSteps hasReadToEnd={hasReadToEnd} onAcknowledge={onAcknowledge} />
  </PanelCard>
);

export default AcknowledgePanel;
